/**
 * Routes dossier où la sidenav reste repliée et sans toggle (extraction, classification). La
 * déclaration agentique s'ouvre repliée mais garde son toggle (`isDocumentsDeclarationPath`).
 */
export const DOCUMENTS_EDITOR_SIDENAV_PATH_RE =
  /^\/documents\/[^/]+\/(extraction|classification)\/?$/

const DOCUMENTS_DECLARATION_PATH_RE = /^\/documents\/[^/]+\/declaration\/?$/

export function isDocumentsDeclarationPath(pathname: string): boolean {
  return DOCUMENTS_DECLARATION_PATH_RE.test(pathname)
}

const DOCUMENTS_STATIC_SEGMENTS = new Set(['list', 'exported', 'deleted'])

export function isDocumentsEditorSidenavPath(pathname: string): boolean {
  return DOCUMENTS_EDITOR_SIDENAV_PATH_RE.test(pathname)
}

export function isDocumentsBatchImportEntryPath(pathname: string): boolean {
  const match = pathname.match(/^\/documents\/([^/]+)\/?$/)
  if (!match) {
    return false
  }
  return !DOCUMENTS_STATIC_SEGMENTS.has(match[1])
}

export function isDocumentsReturnUrlPath(pathname: string): boolean {
  return (
    isDocumentsEditorSidenavPath(pathname) ||
    isDocumentsDeclarationPath(pathname) ||
    isDocumentsBatchImportEntryPath(pathname)
  )
}
